var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMoodboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 57,
    viewBox: "0 0 74 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.94095 57H70.0387C72.2235 57 73.9796 55.1993 73.9796 53.0054V3.99455C74 1.80065 72.2235 0 70.0387 0H56.276C55.2346 0 54.234 0.413943 53.4785 1.17974L45.5762 9.18954C44.8411 9.93464 43.8405 10.3693 42.7787 10.3693H3.94095C1.77649 10.3486 0 12.1492 0 14.3431V52.9847C0 55.1993 1.77649 57 3.94095 57Z",
    fill: "#a890fe"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1358 4.86383H6.73841C4.55353 4.86383 2.79746 6.66449 2.79746 8.85839V10.5142C1.18433 11.0316 0 12.5425 0 14.3431V3.99455C0 1.77996 1.77649 0 3.94095 0H17.7036C18.745 0 19.7456 0.413943 20.5011 1.17974L24.1358 4.86383Z",
    fill: "#a890fe"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8437 4.86377L45.5965 9.16878C44.8614 9.91388 43.8608 10.3485 42.799 10.3485H3.94085C3.53246 10.3485 3.14449 10.4106 2.79736 10.5141V8.85832C2.79736 6.64373 4.57385 4.86377 6.73831 4.86377H49.8437Z",
    fill: "#FFF5E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMoodboard);
export default __webpack_public_path__ + "static/media/ic_moodboard.be5c85ca9aebf259fdd4044db75222b7.svg";
export { ForwardRef as ReactComponent };